import moment from "moment";
export const prepareEmpresaAfiliado = (empresaAfiliado = {}) => ({
  ...empresaAfiliado,
  fechaDesde: empresaAfiliado.fechaDesde !=='' ? moment(empresaAfiliado.fechaDesde).toDate() : null,
  fechaHasta: empresaAfiliado.fechaHasta !== '' ? moment(empresaAfiliado.fechaHasta).toDate() : null,
  fechaAlta: empresaAfiliado.fechaAlta !== '' ? moment(empresaAfiliado.fechaAlta).toDate() : null,
  fechaBaja: empresaAfiliado.fechaBaja !== '' ? moment(empresaAfiliado.fechaBaja).toDate() : null,
});
